import script from "./PodcastAdminCampaignsList.vue?vue&type=script&setup=true&lang=js"
export * from "./PodcastAdminCampaignsList.vue?vue&type=script&setup=true&lang=js"

import "./PodcastAdminCampaignsList.vue?vue&type=style&index=0&id=89a961ac&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-89a961ac"]])

export default __exports__